import type { Faq } from './schema'

/** The questions people ask before they write (v1 src/data/faqs.ts). Pages pick the ones that answer their own objection. */
export const faqs = {
  whatYouDo: {
    question: 'What do you do?',
    answer: 'I set up and manage GoHighLevel accounts: CRM and pipelines, workflows and automations, funnels, email and SMS campaigns, and Voice AI. I mostly work with health coaches, business coaches, AI agencies and e-commerce brands.',
  },
  fixBroken: {
    question: 'Can you fix a HighLevel setup that is already broken?',
    answer: 'Yes. Workflows that stopped firing, automations looping, funnels underperforming: troubleshooting is a big part of my work. I find the cause, fix it, and document what changed.',
  },
  howStart: {
    question: 'How do we start?',
    answer: 'Book a call and we will look at your current setup and what you want it to do. From there I scope the work and we agree on the next step.',
  },
  where: {
    question: 'Where are you based?',
    answer: 'In the Philippines (GMT+8). I work with clients in Australia and the US.',
  },
  afterWrite: {
    question: 'What happens after I write?',
    answer: 'Your message lands straight in my HighLevel inbox and I reply by email. If it is urgent, grab a time on my calendar instead.',
  },
} satisfies Record<string, Faq>

export const allFaqs: Faq[] = Object.values(faqs)
